<template>
    <div>
        <b-row>
            <b-col>
                <b-card>
                    <div slot="header">
                        <h4>{{$t('USER')}}</h4>
                    </div>
                    <b-tabs>
                        <b-tab>
                            <template slot="title">
                                <i class="fa fa-user-o fa-fw" aria-hidden="true"></i> {{$t('BASIC')}}
                            </template>
                            <br>
                            <user-basic-form></user-basic-form>
                        </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          <i class="fa fa-unlock fa-fw" aria-hidden="true"></i> {{$t('PASSWORD')}}
                        </template>
                        <br>
                        <user-password-basic></user-password-basic>
                      </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>

        </b-row>
    </div>
</template>

<script>

import UserBasicForm from '@/components/user/UserBasicForm'
import UserPasswordBasic from '@/components/user/UserPasswordBasic'
    export default {
        name: "User",
        components: {
          UserBasicForm,
          UserPasswordBasic
        }
    }
</script>

<style scoped>

</style>
